import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { notification } from 'redux/modules/app'
import { blobs as blobsApi } from 'redux/modules/api'

function decorator() {
  return ComposedComponent => {
    @connect(
      ({ api, app, auth }) => ({
        localeId: app.locale.id,
        actions: api.actions,
        activeOrganization: auth.organization
      }),
      { ...blobsApi, notification }
    )
    class Blobs extends Component {
      static propTypes = {}

      static defaultProps = {
        params: {}
      }

      key = uuid.v1()

      render() {
        return <ComposedComponent key={this.key} {...this.props} />
      }
    }
    return Blobs
  }
}

export default decorator
